import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { BotonVolverComponent } from "./components/boton-volver/boton-volver.component";
import { DocumentStatusComponent } from "./components/document-status.component";
import { DropdownlistComponent } from "./components/dropdownlist/dropdownlist.component";
import { InputFormularioComponent } from "./components/input-formulario/input-formulario.component";
import { IndicadorPreguntaComponent } from "./components/indicador-pregunta/indicador-pregunta.component";
import { ConfirmDataComponent } from "./pages/confirm-data/confirm-data.component";
import { DocumentUploadComponent } from "./pages/document-upload/document-upload.component";
import { ModalDocumentTypeComponent } from "./pages/modals/modal-document-type/modal-document-type.component";
import { ModalPensionHistoryComponent } from "./pages/modals/modal-pension-history/modal-pension-history.component";
import { PersonalDataComponent } from "./pages/personal-data/personal-data.component";
import { RequestErrorComponent } from "./pages/request-error/request-error.component";
import { TramitePensionHomeComponent } from "./pages/tramite-pension-home/tramite-pension-home.component";
import { TramitePensionRequestComponent } from "./pages/tramite-pension-request/tramite-pension-request.component";
import { TramitePensionSeguridadComponent } from "./pages/tramite-pension-seguridad/tramite-pension-seguridad.component";
import { TramitePensionStepperComponent } from "./pages/tramite-pension-stepper/tramite-pension-stepper.component";
import { ViaPagoComponent } from "./pages/via-pago/via-pago.component";
import { VideoatencionComponent } from "./pages/video-atencion/video-atencion.component";
import { VoucherPensionComponent } from "./pages/voucher-pension/voucher-pension.component";
import { TramitePensionRoutesModule } from "./tramite-pension-routes.module";
import { TramitePensionAntecedentesComponent } from "./pages/tramite-pension-antecedentes/tramite-pension-antecedentes.component";
import { SwipeRightIconComponent } from "src/assets/tramite-pension/icons/svg/swipe_right/swipe_right.component";

@NgModule({
  imports: [
    CommonModule,
    TramitePensionRoutesModule,
    SharedModule,
    PersonalDataComponent,
    DropdownlistComponent,
    BotonVolverComponent,
    InputFormularioComponent,
    TramitePensionAntecedentesComponent,
    TramitePensionHomeComponent,
    SwipeRightIconComponent,
    TramitePensionSeguridadComponent,
  ],
  declarations: [
    TramitePensionStepperComponent,
    TramitePensionRequestComponent,
    VideoatencionComponent,
    ModalPensionHistoryComponent,
    VoucherPensionComponent,
    RequestErrorComponent,
    DocumentUploadComponent,
    DocumentStatusComponent,
    ModalDocumentTypeComponent,
    ConfirmDataComponent,
    ViaPagoComponent,
    IndicadorPreguntaComponent,
  ],
  providers: [],
})
export class TramitePensionModule { }
